/** Composition root for app-wide providers (React Query, auth, toasts). */
import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../lib/queryClient";
import { AuthProvider } from "../context/AuthContext";
import { Toaster } from "../components/ui/Toast";

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      {children}
      <Toaster />
    </AuthProvider>
  </QueryClientProvider>
);
